import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-title',
  standalone: true,
  imports: [CommonModule],
  template: ''
})
export class TitleComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private titleService: Title
  ){}
  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter(route => route.outlet === 'primary'),
      mergeMap(route => route.data)
    ).subscribe(data => {
      const titleKey = data['titleKey'];
      if (titleKey) {
        this.translate.get(titleKey).subscribe(translatedTitle => {
          const title = 'Joyfood+ | ' + translatedTitle;
          this.titleService.setTitle(title);
        });
      } else {
        this.titleService.setTitle('Joyfood+');
      }
    });
  }
}
